module.exports = __webpack_public_path__ + "img/ic_mentalhealth.b9e1442a.png";